'use client';
import { useLocation, useNavigate } from '@/lib/router';
import { hasConsent } from '../../lib/cookieConsent';

const ScrollLink = ({ to, children, className = 'links', description = '', rel = null }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    const [pathname, hash] = to.split('#');

    if (hasConsent('performance') && typeof window.gtag === 'function') {
      window.gtag('event', 'click', {
        event_category: pathname,
        event_action: 'click',
        event_label: hash,
        event_description: description
      });
    }
    
    

    if (location.pathname === pathname && location.hash === `#${hash}`) {
      // Re-scroll to the section manually
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(to);
    }
  };

  const relAttr = rel ? { rel } : {};
  return <a href={to} onClick={handleClick} className={className} {...relAttr}>{children}</a>;
};

export default ScrollLink;
